import {debounce} from "js/utils"

export {}

const responseSettings = {
  method: "GET",
}

type searchResult = {
  html: string
}

const SEARCH_ENDPOINT = "/wp-json/jip/v1/search-suggest"

const headerSearches = document.querySelectorAll(".m-header-search")
const mainOverlay = document.querySelector(".c-overlay-main")
const openers = document.querySelectorAll(".--js--main-search-opener")
const closers = document.querySelectorAll(".--js-main-search-closer")

headerSearches.forEach((headerSearch) => {
  let filterAbortController: AbortController | null = null

  const input = headerSearch.querySelector<HTMLInputElement>("input.f-text__input")
  const dropdown = headerSearch.querySelector(".m-header-search__dropdown")
  const dropdownList = dropdown?.querySelector(".m-header-search__dropdown-list")

  const open = () => {
    headerSearch.classList.add("--open")
    mainOverlay?.classList.add("--show")
    input?.focus()
  }
  const close = () => {
    headerSearch.classList.remove("--open")
    mainOverlay?.classList.remove("--show")
    input?.blur()
  }

  openers.forEach((opener) => opener.addEventListener("click", open))
  closers.forEach((closer) => closer.addEventListener("click", close))

  if (!input) return

  const fetchSearch = async () => {
    if (filterAbortController) {
      filterAbortController.abort()
    }

    filterAbortController = new AbortController()
    const {signal} = filterAbortController

    dropdown?.classList.add("--loading")
    let removeLoading = true

    try {
      const searchParam = input.value ? `?s=${input.value}` : ""
      const url = `${SEARCH_ENDPOINT}${searchParam}`
      const response = await fetch(url, {
        ...responseSettings,
        signal,
      })
      const data: searchResult = await response.json()
      if (data.html && dropdownList) dropdownList.innerHTML = data.html
    } catch (error) {
      if (error instanceof Error && error.name === "AbortError") {
        console.log("Previous fetch aborted.")
        removeLoading = false
      } else {
        console.error("Error:", error)
      }
    } finally {
      if (removeLoading) dropdown?.classList.remove("--loading")
    }
  }

  input.addEventListener("input", debounce(fetchSearch, 500))
})
